export const numberHelper = {
  parseToPercent(value: number | undefined) {
    if (value === undefined) {
      return
    } else {
      if (value > 0) return value * 100
    }
  },
}
